<template>
    <div>
        <div class="search-box">
            <!-- <p>检查类型：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.checkType" >                        
                <a-select-option  value="中期检查">中期检查</a-select-option>
                <a-select-option  value="期末检查">期末检查</a-select-option>
            </a-select> -->
            <!-- <p>系别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.departmentCode" >
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select> -->
            <p>学年：</p>
            <a-date-picker
                class="input-box-short"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>学期：</p>
            <a-select class="input-box-short" allowClear v-model="searchFrom.semester" >
                <!-- For years before 2025, keep all options -->
                <template v-if="year < '2025'">
                    <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                </template>
                <!-- For 2025 and later, only show two semesters -->
                <template v-else>
                    <a-select-option :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                </template>
            </a-select>
            <p>学生姓名或学号：</p>
            <a-input class="input-box" v-model="searchFrom.studentNoOrName" />
            <p>教师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <p v-if="permissions.indexOf('undergraduate:culture:paperInspect:college')>-1">数据范围：</p>
            <a-select class="input-box" default-value="guide"  v-model="searchFrom.dataRange" v-if="permissions.indexOf('undergraduate:culture:paperInspect:college')>-1">                        
                <a-select-option  value="guide">我指导的论文</a-select-option>
                <a-select-option  value="inspect">我评估的论文</a-select-option>
            </a-select>
            <p v-if="permissions.indexOf('undergraduate:culture:paperInspect:collegeCommit')>-1 || permissions.indexOf('undergraduate:culture:paperInspect:college')>-1">学院自查：</p>
            <a-select class="input-box-short" allowClear v-model="searchFrom.collegeStatus" v-if="permissions.indexOf('undergraduate:culture:paperInspect:collegeCommit')>-1|| permissions.indexOf('undergraduate:culture:paperInspect:college')>-1">                        
                <a-select-option  value="saved">已保存</a-select-option>
                <a-select-option  value="commit">已提交</a-select-option>
            </a-select>
            <p>完整性与规范性：</p>
            <a-select class="input-box-short" allowClear v-model="searchFrom.integrityNormative">                        
                <a-select-option  value='true' >已完善</a-select-option>
                <a-select-option  value='false' >需完善</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <!-- <div class="search-box">
            
            
            

        </div> -->
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/undergraduate/quality/papercheck/info?type=add')"
                v-if="permissions.indexOf('undergraduate:culture:paperInspect:add')>-1"
                >
                 新增
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button
                    v-if="permissions.indexOf('undergraduate:culture:paperInspect:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                v-if="permissions.indexOf('undergraduate:culture:paperInspect:edit')>-1"
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :paperCheck('edit')"
                >
                 编辑
            </a-button>
            <a-button 
                type="primary"
                icon="export" 
                class="btn" 
                @click="exportFile()"
                v-if="permissions.indexOf('undergraduate:culture:paperInspect:export')>-1">
                 导出
            </a-button>
            <a-button 
                type="primary"
                icon="plus" 
                class="btn"
                v-if="permissions.indexOf('undergraduate:culture:paperInspect:college')>-1"
                @click="paperCheck('midterm')"
                >
                 中期检查
            </a-button>
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('undergraduate:culture:paperInspect:college')>-1"
                @click="selfCheck()"
                >
                 学院自查
            </a-button>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                v-if="permissions.indexOf('undergraduate:culture:paperInspect:collegeCommit')>-1"
                @click="commit()"
                >
                 批量提交
            </a-button>
            <a-button  v-if="permissions.indexOf('undergraduate:culture:paperInspect:query')>-1" type="primary" class="btn" icon="file-search" @click="selectedRowKeys[0] == null ? selectedCheck() :paperCheck('look')" >查看详情</a-button>

        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ y: '600px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
        <!-- <div class="pagination">
            <a-pagination 
          :total="pagination.total" 
          v-model="pagination.current"
          show-size-changer 
          show-quick-jumper 
          :page-size-options="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          @change="pageChange"
          @showSizeChange="onShowSizeChange"
          :show-total="pagination.showTotal"
        />
        </div> -->
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,exportFile,collegeCommit } from '@/baseAPI/undergraduate/culture/paperCheck'
    import { getSchoolYear,selectedCheck,getSemester,transformSeason } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        data () {
            return {
                userId:'',
                xbArr:[],
                data:[],
                loading: false,
                pagination:{
                    current: 1,//当前页数
                    pageSize: 10,
                    pageSizeOptions: ['10', '20', '100'],
                    showTotal: (total, range) => {
                    return " 共" + total + "条"
                    },
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    studentNoOrName:'',
                    teacherName:'',
                    checkLevel:'',
                    semester:'',
                    schoolYear:'',
                    departmentCode:'',
                    dataRange:'guide'
                },
                permissions:[],
                year:'',
                yearShowOne:false,
                courseId:'',
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                sysRoles:[],
                columns:[
                        {
                            title: '序号',
                            align:'center',
                            width:'4%',
                            customRender: (text, row, index) => {
                                return { children: index+1+''};
                            },
                        },
                        // {
                        //     title: '检查类型',
                        //     width:'7%',
                        //     dataIndex: 'checkType',
                        //     align:'center',
                        // },
                        {
                            title: '学年',
                            width:'10%',
                            dataIndex: 'schoolYear',
                            align:'center',
                        },
                        {
                            title: '学期',
                            dataIndex: 'semester',
                            align:'center',
                            width:'7%',
                            customRender: (text, row, index) => {
                                return transformSeason(text)
                            },
                        },
                        {
                            title: '论文题目',
                            width:'30%',
                            dataIndex: 'paperTitle',
                            ellipsis:true,
                            align:'left',
                        },
                        {
                            title: '学生姓名',
                            dataIndex: 'studentName',
                            width:'10%',
                            ellipsis:true,
                            align:'center'
                        },
                        {
                            title: '学号',
                            dataIndex: 'studentNo',
                            align:'center'
                        },
                        {
                            title: '教师姓名',
                            dataIndex: 'teacherName',
                            align:'center'
                        },
                        {
                            title: '中期检查',
                            width:'7%',
                            dataIndex: 'middleComment',
                            align:'center',
                            customRender: (text, row, index) => {
                                return (text == null || text =='')?'-':'是'
                            },
                        },
                        {
                            title: '学院自查',
                            width:'7%',
                            dataIndex: 'collegeStatus',
                            align:'center',
                            customRender: (text, row, index) => {
                                if(text=='commit'){
                                    text='已提交'
                                }else if(text=='saved'){
                                    text='已保存'
                                }
                                return text;
                            },
                        },
                        {
                            title: '完整性与规范性',
                            width:'7%',
                            dataIndex: 'integrityNormativeComment',
                            align:'center',
                            customRender: (text, row, index) => {
                                // return (text == null || text =='')?'已完善':'需完善'
                                return text;
                            },
                        },
                    ]
            }
        },
        mounted () {
            this.selectedRowKeys = []
            this.userId=this.$store.state.user.userId
            // this.searchFrom.dataRange='guide'
            this.$store.state.user.sysRoles.forEach(element => {
                this.sysRoles.push(element.code)
            });
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })

            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.searchFrom.semester=getSemester()
            this.fetch()
        },
        watch:{
            '$route':{
                handler(newVal,oldVal){
                    if(newVal.path === '/admin/undergraduate/quality/paperCheck'){
                        this.fetch()
                    }
                },
                deep:true,
                immediate:true
            }
        },
        methods:{
            commit(){
                
                var map={};
                this.data.forEach(element=>{
                    map[element.id]=element
                })
                var flag=false; 
                this.selectedRowKeys.forEach(element=>{
                    if(map[element].collegeStatus==null || map[element].collegeStatus=='' || map[element].collegeStatus=='commit'){
                        flag=true
                    }
                })
                
                if(flag){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能提交已保存的',
                    });
                }else{
                    if(this.selectedRowKeys.length > 0){
                        collegeCommit(this.selectedRowKeys).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'批量提交成功',
                                });
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                            this.fetch()
                        })
                    }else{
                        this.$notification['info']({
                            message: '提示',
                            description:'请选择记录',
                        });
                    }
                }
            },
            selectedCheck(){
                selectedCheck()
            },
            exportFile(){
                exportFile(this.searchFrom).then(res=>{
                    if(res){
                        this.$notification['success']({
                            message: '成功',
                            description:'导出论文抽查成功',
                        });
                        window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })  
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.courseId=record.courseInfoId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize=pagination.pageSize;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records
                    this.loading = false;
                })
            },
            searchList(){
                this.selectedRowKeys=[]
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                if(this.selectedRowKeys.length>0){
                    del(id).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除论文抽查信息成功',
                            });
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择论文抽查信息再进行删除',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
            paperCheck(type){
                var selected={teacherId:''};
                if(type=='midterm'){
                    this.data.forEach(element=>{
                        if(element.id == this.selectedRowKeys[0]){
                            selected = element;
                        }
                    })
                }
                if(type=='midterm' && selected.teacherId==this.userId){
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择您所评估的论文',
                    });
                }else if(this.selectedRowKeys.length==1){   
                    this.$router.push('/admin/undergraduate/quality/papercheck/info?type='+type+'&id='+this.selectedRowKeys[0]) 
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择一篇论文',
                    });
                }
            },
            selfCheck(){
                var selected={teacherId:''};
                this.data.forEach(element=>{
                    if(element.id == this.selectedRowKeys[0]){
                        selected = element;
                    }
                })
                if( selected.teacherId==this.userId){
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择您所评估的论文',
                    });
                }else if(this.selectedRowKeys.length==1){  
                    var type;
                    if(selected.collegeStatus == 'saved'){
                        type='edit'
                    }else if(selected.collegeStatus == 'commit'){
                        type='look'
                    }else{
                        type='add'
                    }
                    this.$router.push('/admin/undergraduate/quality/selfcheck/info?type='+type+'&studentName='+selected.studentName
                    +'&studentNo='+selected.studentNo+'&teacherName='+selected.teacherName+'&paperTitle='+selected.paperTitle
                    +'&id='+selected.id)
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择一篇论文',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .search-box-1
    {
        margin-bottom: 10px;
    }

    .search-box-1 p
    {
        display: inline-block;
    }
    .search-box-1 .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box-1 .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }

    .search-box .input-box-short{
        margin-right: 1rem;
        width: 7rem;
    }

    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
    .pagination{
        margin-top: 15px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
</style>
